import React from 'react';
import { useParams } from 'react-router-dom';
import ClientDetailsLegacy from './legacy/ClientDetails.js';
import ClientDetailsEnhanced from './enhanced/ClientDetailsEnhanced.js';

const ClientRouter = () => {
	const { username } = useParams();

	// Feature flag - can be environment variable or user preference
	const useEnhancedClient =
		process.env.REACT_APP_ENHANCED_CLIENT === 'true' || false;

	// Enable enhanced client details for testing
	// Change this to false to use legacy view, true for enhanced view
	const shouldUseEnhanced = useEnhancedClient || true;

	if (shouldUseEnhanced) {
		return <ClientDetailsEnhanced />;
	}

	return <ClientDetailsLegacy />;
};

export default ClientRouter;
